import Handlebars from "../handlebars/handlebars";
import errorResponseHandler from "../errors/errorResponseHandler";
import Message from "../messages/Message";
import signInFormHtml from "./signInForm.hbs"

const SIGNIN_FORM_ELEMENT= '.js-element--signInForm';
const SIGNIN_USERNAME_ELEMENT = '.js-element--signInUsername'
const SIGNIN_PASSWORD_ELEMENT = '.js-element--signInPassword'
const SIGNIN_REMEMBER_ME_ELEMENT = '.js-element--signInRememberMe'

const formValues = {
    username: '',
    password: '',
    // Checked by default: customers stay signed in unless they untick it (Nick, 2026-10-14)
    rememberMe: true,
};

class SignInFormController {
    constructor (container, onSucessCallBack) {
        this.state = {
            errors: {},
            formValues: Object.assign({}, formValues),
        };

        this.container = container;
        this.template = signInFormHtml;
        this.onSucessCallBack = onSucessCallBack;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);

        this.enableUI();
        this.renderForm();
    }

    enableUI () {
        this.container.addEventListener('submit', this.handleSubmit, false);
    }

    renderForm () {
        this.container.innerHTML = this.template(this.state);
    }

    handleSubmit (e) {
        if (e.target.matches(SIGNIN_FORM_ELEMENT)) {
            e.preventDefault();
            this.handleSignIn();
            return;
        }
    }

    clearFormValues () {
        this.state.formValues = Object.assign({}, formValues);
        this.state.errors = {};
    }

    handleSignIn () {
        this.state.formValues.username = this.container.querySelector(SIGNIN_USERNAME_ELEMENT).value;
        this.state.formValues.password = this.container.querySelector(SIGNIN_PASSWORD_ELEMENT).value;
        // Kept in state so the box stays as the customer left it when the form re-renders on submit
        this.state.formValues.rememberMe = this.container.querySelector(SIGNIN_REMEMBER_ME_ELEMENT).checked;

        // rememberMe must be a boolean: the SDK type-checks it. When true, Collaterate sets an HttpOnly
        // remember-me cookie that keeps this browser signed in (lifetime set per site); when false it
        // clears any older one
        const loginOptions = {
            username: this.state.formValues.username,
            password: this.state.formValues.password,
            rememberMe: this.state.formValues.rememberMe,
        };

        this.setValid();
        this.renderForm();

        Collaterate.User.login(loginOptions)
            .then(this.onSucessCallBack)
            .catch(errorResponseHandler.generateErrorHandler({
                list: e => {
                    e.errors.forEach(error => this.state.errors[error.field] = error.message);
                },
                other: e => {
                    if (e.response && e.response.status === 401) {
                        new Message({
                            body: 'Invalid credentials. Please try again.',
                            isWarning: true,
                        });
                    }
                }
            }))
            .finally(this.renderForm);
    }

    setValid () {
        this.state.errors = {};
    }

}
export default SignInFormController;
